// extracted by mini-css-extract-plugin
export default {"bg":"HeaderAboutUs_bg__3rWZT","titre":"HeaderAboutUs_titre__zV7N2","container":"HeaderAboutUs_container__ZGDdz"};